import React from 'react';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { dateToFormat } from 'src/utils/date';
import { useTranslation } from 'react-i18next';
import { Button, Typography, Alert } from '@mui/material';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { BackdropLoader } from '@livable/saas-react-components';
export const ModalContent = observer(_ref => {
  var _store$payment$getCur, _store$payment$getCur2, _store$payment$getCur3;
  let stripeRefundId = _ref.stripeRefundId,
    reloadData = _ref.reloadData,
    handleModalClose = _ref.handleModalClose;
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const modalFooterClasses = useModalFooterStyles();
  const handleSubmit = async () => {
    const resp = await store.payment.postUndoRefundAsync.run({
      stripeRefundId: stripeRefundId
    });
    if (resp.isSuccessful) toast('success', {
      body: ['Successfully saved']
    });
    reloadData();
    handleModalClose();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Alert, {
    severity: "warning",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Notice! You are about to dismiss the refund for the invoice:", ' ', (_store$payment$getCur = store.payment.getCurrentStripeInvoicesByRefundId(stripeRefundId)) === null || _store$payment$getCur === void 0 ? void 0 : _store$payment$getCur.invoiceNumber, ", Charge for Subscription issued on ", dateToFormat((_store$payment$getCur2 = store.payment.getCurrentStripeInvoicesByRefundId(stripeRefundId)) === null || _store$payment$getCur2 === void 0 ? void 0 : _store$payment$getCur2.paidAt), ". Refund amount $", (_store$payment$getCur3 = store.payment.getCurrentStripeInvoicesByRefundId(stripeRefundId)) === null || _store$payment$getCur3 === void 0 ? void 0 : _store$payment$getCur3.amount)), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooterStandart
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleModalClose
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "contained",
    onClick: handleSubmit,
    disabled: !stripeRefundId
  }, t('Dismiss refund')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: false
  }));
});